import { render, staticRenderFns } from "./bjgwyfbj.vue?vue&type=template&id=113e3482&scoped=true&"
import script from "./bjgwyfbj.vue?vue&type=script&lang=js&"
export * from "./bjgwyfbj.vue?vue&type=script&lang=js&"
import style0 from "./bjgwyfbj.vue?vue&type=style&index=0&id=113e3482&lang=less&scoped=true&"
import style1 from "./bjgwyfbj.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e3482",
  null
  
)

export default component.exports